// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components----footer-module---root---oVj8I","socialIcon":"src-components----footer-module---socialIcon---A-Z9E","copyright":"src-components----footer-module---copyright---4FyNV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/footer.module.scss
// module id = 446
// module chunks = 114276838955818